import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getThemeProp } from '@amtrav/themes';

// this is a singleton dropdown component made
// just for this account setup form
const SelectBoxStyled = styled.select`
  width: 100%;
  height: 35px;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  color: ${getThemeProp('global.textBody--color')};
  background: white;
  border-style: solid;
  border-width: ${getThemeProp('textfield.borderWidth--standard')};
  border-color: ${(props) => props.borderColor};
  border-radius: ${getThemeProp('global.borderRadius--size')};
  box-shadow: ${getThemeProp('textfield.box-shadow')};
  padding-left: 5px;
  font-size: 14px;

  option {
    color: ${getThemeProp('global.textBody--color')};
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }

  &:focus {
    outline: none;
  }
`;

const SelectBox = ({ children, value, borderColor, name, onBlur, onChange }) => {
  return (
    <SelectBoxStyled value={value} borderColor={borderColor} name={name} onBlur={onBlur} onChange={onChange}>
      {children}
    </SelectBoxStyled>
  );
};

export default SelectBox;

SelectBox.propTypes = {
  borderColor: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  children: PropTypes.element,
};

SelectBox.defaultProps = {
  borderColor: '#d1e0f6',
};
